import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';

// Language is pinned to en-US — see LocalesProvider for why.
// LanguageDetector is deliberately NOT used: it would re-detect from the
// browser and, worse, keep writing `i18nextLng` to localStorage, which is the
// stale value that used to leak a Spanish locale back into AppStateStore.
i18n
    // load translation using http -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        lng: 'en-US',
        fallbackLng: 'en-US',
        supportedLngs: ['en-US'],
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });


export default i18n;
